import { SquaresUnite } from "lucide-react";
import React from "react";

export const EmptyState: React.FC = () => (
  <div className="flex flex-col items-center justify-center py-8 text-center">
    <SquaresUnite className="mb-2 h-8 w-8 text-gray-300" />
    <p className="text-sm font-medium text-gray-500">No items yet</p>
    <p className="mt-1 text-xs text-gray-400">Create your first prompt to get started</p>
  </div>
);
